'use client'

import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts'

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import { injuryData } from '@/lib/chart-data'

const chartConfig = {
  injuries: {
    label: 'Injuries',
    color: 'var(--chart-3)',
  },
} satisfies ChartConfig

export function Injuries() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Yearly Injuries Along SR-347</CardTitle>
        <CardDescription>
          Injuries on SR-347 peaked at 146 in 2016, with generally high numbers, averaging above
          100, from 2014 to 2023.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <BarChart accessibilityLayer data={injuryData}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="year" tickLine={false} tickMargin={10} axisLine={false} />
            <YAxis tickLine={false} axisLine={false} />
            <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
            <Bar dataKey="injuries" fill="var(--color-injuries)" radius={4} />
          </BarChart>
        </ChartContainer>
      </CardContent>
      <CardFooter className="text-muted-foreground text-sm italic">
        Data collected from the Arizona Department of Transportation (ADOT) via a public records
        request.
      </CardFooter>
    </Card>
  )
}
